import { Link } from 'react-router-dom'
import { EVENT_THEME, VENUE } from '../../content/event'
import { EVENT_DATE_LABEL, EVENT_HOURS_LABEL } from '../../event/schedule'

/**
 * The landing hero: the approved hackathon artwork on the royal field it was
 * drawn for.
 *
 * White on `#1E40AF` is 8.72:1, so every line here clears AA for body text.
 * The call to action is accent-600 with white text (4.69:1); against the blue
 * the orange alone is 1.86:1, so a white outline marks the control's edge.
 */
export default function EventHero() {
  return (
    <section className="flex flex-1 items-center bg-[var(--color-royal)] text-white">
      <div className="page-shell grid w-full items-center gap-8 py-10 sm:py-14 md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] md:gap-12">
        <img
          src="/art/hackathon-2026.svg"
          alt="2026 Hackathon artwork: Julius in a hard hat, holding a brick, with a thought bubble reading From Idea to Impact."
          width={1161}
          height={1412}
          className="mx-auto h-auto w-full max-w-[16rem] sm:max-w-xs md:max-w-sm"
        />
        <div className="flex flex-col gap-4">
          {/* Broken by phrase, not by width: the idea on one line, the impact on the next. */}
          <h1 className="wordmark-display-fluid" aria-label={EVENT_THEME}>
            <span className="block">From Idea</span> <span className="block">to Impact</span>
          </h1>
          <div className="text-lg">
            <p className="font-semibold">{EVENT_DATE_LABEL}</p>
            <p>{EVENT_HOURS_LABEL} Eastern</p>
            <p>{VENUE.name}, Reston, VA</p>
          </div>
          <div className="flex flex-wrap gap-3 pt-2">
            <Link
              to="/participant"
              className="rounded-md border-2 border-white bg-[var(--color-accent-600)] px-5 py-3 font-bold text-white hover:bg-[var(--color-accent-700)]"
            >
              Participant space
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
